export enum NotificationsType {
  push = 'push',
  carecircle = 'carecircle',
  email = 'email',
}
